import { getStore, GridStoreHolder } from 'controls/grid/utils/getStore';
import { GridDataEntry } from 'controls/grid/gridDataEntry';
import { observer } from 'mobx-react';
import React from 'react';

export const ColumnSelectorCountIndicator = observer(
	<T extends GridDataEntry>(props: { store: GridStoreHolder<T> }) => {
		const store = getStore(props.store);
		return (
			<div className="column-selector-count-indicator">
				{store.columns.visible.length}/{store.columns.all.length}
			</div>
		);
	},
);
